export default function TableTheme(theme) {
    return {
        MuiPaper: {
            styleOverrides: {
                root: {
                    '&.MuiTableContainer-root': {
                        borderRadius: theme.shape.borderRadius,
                        boxShadow: 'none',
                        border: `1px solid ${theme.palette.divider}`,
                        overflowX: 'auto',
                        maxWidth: '100%',
                        display: 'block'
                    },
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderCollapse: 'separate',
                    borderSpacing: 0,
                    backgroundColor: theme.palette.background.paper,
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.paper,
                    '& .MuiTableCell-head': {
                        color: theme.palette.table.head.txtcolor,
                        fontWeight: 900,
                        fontSize: '13px',
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        height: '50px !important',
                        padding: '0px 20px !important',
                        fontFamily: 'Lato',
                        whiteSpace: 'nowrap',
                        backgroundColor: theme.palette.table.head.bgcolor,
                        minWidth: 'max-content',
                        '&:last-child': {
                            borderRight: 'none',
                        },
                        '& .MuiTableSortLabel-root': {
                            padding: 0,
                            color: theme.palette.text.primary,
                            fontWeight: 900,
                            '& .MuiTableSortLabel-icon': {
                                color: `${theme.palette.text.primary} !important`,
                                fontSize: '18px',
                                marginLeft: '4px'
                            },
                            '&:hover': {
                                color: theme.palette.text.primary,
                                '& .MuiTableSortLabel-icon': {
                                    color: theme.palette.grey[900],
                                },
                            },
                            '&.Mui-active': {
                                color: theme.palette.text.primary,
                                '& .MuiTableSortLabel-icon': {
                                    color: theme.palette.grey[900],
                                },
                            },
                        }
                    }
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    transition: 'background-color 0.15s ease',
                    '&:hover': {
                        backgroundColor: theme.palette.background.paper,
                    }
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    fontFamily: 'Lato',
                    fontSize: '13px',
                    color: theme.palette.table.head.txtcolor,
                    whiteSpace: 'nowrap',
                    height: '50px !important',
                    padding: '0px 20px !important',
                }
            }
        },
        MuiPagination: {
            styleOverrides: {
                root: {
                    padding: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    borderRadius: theme.shape.borderRadius,
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.text.primary,
                        '&:hover': {
                            backgroundColor: theme.palette.primary.dark,
                        }
                    }
                }
            }
        },
    };
}